import { Stack, StackProps, Typography } from '@mui/material';
import { ProgramCard } from '@widgets/programs/index.ts';
import { formatRuSmartDateFromDMY } from '@shared/helpers/format-ru-smart-date.ts';
import { useMobile } from '@shared/hooks/index.ts';
import * as main from '@shared/styles/abstracts/vars.module.scss';
import { Program } from '@shared/types/programs';

export type HistoryGroupedPrograms = Record<
  string,
  Array<
    Program & {
      elementIndex: number;
      dateWithoutTimeInformation: string;
    }
  >
>;

type ProgramHistoryListPT = {
  groupedPrograms: HistoryGroupedPrograms;
  onProgramClick: () => void;
  programsListLength: number;
} & StackProps;

export const ProgramHistoryList = (props: ProgramHistoryListPT) => {
  const { groupedPrograms, onProgramClick, programsListLength, ...rest } = props;
  const { isMobile } = useMobile();
  return (
    <Stack gap={'20px'} {...rest}>
      {Object.keys(groupedPrograms).map((date) => (
        <Stack gap={'10px'} key={date}>
          <Typography
            sx={{
              color: main.colorTextSecondary,
              fontSize: main.fontSmall,
              lineHeight: '18px',
            }}
          >
            {formatRuSmartDateFromDMY(date)}
          </Typography>
          <Stack gap={'10px'}>
            {groupedPrograms[date].map((program) => (
              <ProgramCard
                activeTab={'all'}
                needDropDawnShowUp={
                  programsListLength - 1 === program.elementIndex &&
                  (isMobile ? programsListLength > 1 : programsListLength > 6)
                }
                key={program.elementIndex}
                program={program}
                onClick={onProgramClick}
              />
            ))}
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};
